import { Clock, Timer, ListChecks, FileText } from "lucide-react";
import SimpleMarkdown from "../common/SimpleMarkdown";

// Read-only look at a toolkit item, as the patient will see it.
export const TYPE_LABEL = { worksheet: "Worksheet", exercise: "Exercise", psychoeducation: "Reading", protocol: "Clinician guide" };
export const TYPE_STYLE = {
  worksheet: "bg-sky-100 text-sky-800", exercise: "bg-emerald-100 text-emerald-800",
  psychoeducation: "bg-violet-100 text-violet-800", protocol: "bg-amber-100 text-amber-800",
};

export default function ToolkitPreview({ item }) {
  if (!item) return null;
  const fields = item.worksheet_schema?.fields || [];
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${TYPE_STYLE[item.type] || "bg-secondary-100 text-secondary-700"}`}>{TYPE_LABEL[item.type] || item.type}</span>
        {item.category && <span className="text-xs text-secondary-600">{item.category}</span>}
        {item.minutes && <span className="inline-flex items-center gap-1 text-xs text-secondary-600"><Clock className="w-3.5 h-3.5" />{item.minutes} min</span>}
        {item.source === "org" && <span className="rounded-full bg-primary-50 px-2 py-0.5 text-[11px] font-semibold text-primary-700">Your clinic</span>}
      </div>
      {item.description && <p className="text-sm font-medium text-secondary-800">{item.description}</p>}
      {item.body_markdown && <SimpleMarkdown text={item.body_markdown} />}
      {item.steps?.length > 0 && (
        <div>
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-secondary-500 mb-1"><ListChecks className="w-4 h-4" /> Steps</p>
          <ol className="list-decimal pl-5 space-y-1 text-sm text-secondary-700">{item.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
        </div>
      )}
      {item.timer && (
        <p className="flex items-center gap-1.5 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-900">
          <Timer className="w-4 h-4" /> Guided timer: {item.timer.phases.map((p) => `${p.label} ${p.seconds}s`).join(" · ")}, {item.timer.rounds} rounds
        </p>
      )}
      {fields.length > 0 && (
        <div>
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-secondary-500 mb-1">
            <FileText className="w-4 h-4" /> {item.worksheet_schema.repeatable ? `The patient fills in (as many ${item.worksheet_schema.entry_label || "entries"}s as they like)` : "The patient fills in"}
          </p>
          <ul className="space-y-1 text-sm text-secondary-700">
            {fields.map((f) => <li key={f.key}>• {f.label}{f.required ? "" : <span className="text-secondary-400"> (optional)</span>}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
